function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.333,
  width: 40,
  height: 40,
  rx: 6,
  fill: "#F88962"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.334 15.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM31.534 17.6h-22.4c-.8 0-1.12 1-.44 1.44l5.84 3.76c.28.2.44.56.32.88l-2.2 7.32c-.24.8.8 1.36 1.4.76l5.68-6c.32-.36.88-.36 1.2 0l5.68 6c.56.6 1.6.04 1.4-.76l-2.2-7.32c-.08-.32.04-.68.32-.88l5.84-3.76c.68-.44.36-1.44-.44-1.44z",
  fill: "#fff"
});

var SvgSfLead = function SvgSfLead(props) {
  return React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgSfLead;